import { createPinia } from "pinia";
import App from "./App.ce.vue";

// setup() runs once at custom-element registration, so create Pinia during install to keep each host isolated.
const piniaPlugin = {
  install(app) {
    app.use(createPinia());
  },
};

export const setup = () => {
  return Object.freeze({
    component: App,
    plugins: [piniaPlugin],
  });
};
